import styled from 'styled-components';

export const Base = styled.span`
	color: inherit;
	font-weight: 500;
	text-decoration: underline;
	cursor: pointer;

	&:hover {
		opacity: 0.8;
	}
`;

export const DeletedLink = styled.span`
	color: inherit;
	font-weight: 500;
	text-decoration: line-through;
	cursor: pointer;

	&:hover {
		opacity: 0.8;
	}
`;

export const MissingLink = styled.span`
	color: ${({ theme }) => theme.gray[600]};
	font-style: italic;
`;
